import React, { Component } from 'react';
import axios from 'axios';
import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import { Link } from 'react-router-dom'

class CheckoutCancellation extends Component {

    render() {
        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <section className="section about-app-area ptb_50">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-6 text-center">
                                    <h2>Pago cancelado</h2>
                                    <p>No se completó el proceso de pago.</p>

                                    <Link to="/">
                                        <button className="buy-btn mt-3">Volver al inicio</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default CheckoutCancellation;
